import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IDamageFollowUp, IDDFollowUp } from "../models/prException";
import { throwApiError } from "./apiError";
import { getHeaderActionType } from "../helpers";
/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const DamageFollowupAPI = async (
  params: IDamageFollowUp | IDDFollowUp ,
  osdNumber: number,
  action: string,
  osdType?: string,
  terminal?: string
) => {
    try {
      const url = `${getUrl(ApiType.REFUSAL_FOLLOWUP).replace(
        ":osdNumber",
        osdNumber.toString()
      )}/${action}`;
      let headers = {
        "Content-Type": "application/json",
        "OSD-Module-Name": "damagesOrRefusals",
        "OSD-Section-Name": "followup",
        "OSD-Action-Type": getHeaderActionType(action),
        "OSD-Exception-Type": osdType,
        "OSD-Exception-Number": osdNumber?.toString(),
        "OSD-Destination-Terminal": terminal,
      };
      const response = await axios.post(url, params, { headers });
      return response.data;
    } catch (error: any) {
      return throwApiError(error, ErrorMessages.damageFollowUpAPIError, { badRequestOrder: "errorsFirst" });
    }
};

